export default __webpack_public_path__ + "static/media/3.6e059ed6.png";